import React from "react";
import styles from "./capabilities-tags.module.scss";
import { useTranslation } from "gatsby-plugin-react-i18next";

// Mismos términos que mostraba el viejo carrusel HeroBottom; deben quedar en el
// HTML estático del SSR (sin gates tipo useIsReady) para conservar su valor SEO.
const KEYS = [
  "DIGITAL_MARKETING",
  "CAMPAINGNS",
  "OPENBANKING",
  "RT_CAMPAINGNS",
  "ANALYTICS",
  "COMMERCIAL_S",
  "BPM",
  "WALLET",
  "CRM",
  "MOBILE_BANKING",
  "ONLINE_BANKING",
  "AI",
  "REALTIME",
  "OMNICHANNEL",
  "INCENTIVES",
  "COMMERCIAL_P",
  "DIGITAL_OB",
];

const CapabilitiesTags = () => {
  const { t } = useTranslation();
  return (
    <ul className={styles.tags}>
      {KEYS.map((key) => (
        <li key={key}>{t(`HERO.SWIPER.${key}`)}</li>
      ))}
    </ul>
  );
};

export default CapabilitiesTags;
